import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@s/common/auth.service';
import { IframeMessageService } from '@s/iframe-message.service';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  isUserSeeionExpired = false;

  constructor(
    private _authService: AuthService,
    private iframeMessageService: IframeMessageService,
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      tap(),
      catchError((error) => {
        if (error.status === 401) {
          this.iframeMessageService.notifySessionEnd();
          this._authService.logout(true);
        }
        return throwError(error);
      }),
    );
  }
}
